import '@babel/polyfill';
import React from 'react';
import { render } from 'react-dom';
import App from '@app/App';
import { RouteProvider } from '@app/router';
import './common/styles/datepicker-restyle.css';
var appContainer = document.getElementById('app');
render(React.createElement(RouteProvider, null,
    React.createElement(App, null)), appContainer);
